import { useEffect, useState } from 'react'
import moment from 'moment'

const MINUTE_MS = 60 * 1000

const getRemaining = (deadline) => {
  const ms = deadline ? moment(deadline).diff(moment()) : 0

  if (!deadline || !moment(deadline).isValid() || ms <= 0) {
    return { expired: true, ms: 0, days: 0, hours: 0, minutes: 0 }
  }

  const duration = moment.duration(ms)
  return {
    expired: false,
    ms,
    days: Math.floor(duration.asDays()),
    hours: duration.hours(),
    minutes: duration.minutes()
  }
}

// Tiempo que falta hasta `deadline` en días, horas y minutos. Se refresca
// cada minuto: la cuenta regresiva no muestra segundos, así que no hace falta
// re-renderizar más seguido.
const useCountdown = (deadline) => {
  const [remaining, setRemaining] = useState(() => getRemaining(deadline))

  useEffect(() => {
    setRemaining(getRemaining(deadline))
    if (!deadline) return undefined

    const interval = setInterval(() => {
      const next = getRemaining(deadline)
      setRemaining(next)
      if (next.expired) clearInterval(interval)
    }, MINUTE_MS)

    return () => clearInterval(interval)
  }, [deadline])

  return remaining
}

export default useCountdown
